import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { Form } from 'react-final-form';
import { Button } from 'ncoded-component-library';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { useTranslation } from 'react-i18next';
import FileSecurity from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/DataRoomDocumentDrawers/ManageFileAccess/components/FileSecurity';
import { getPayloadBulkFileSettings } from 'router/subrouters/DataRoom/utils';
import ScopeModal from './components/ScopeModal';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';

import './DocumentsGlobalSecurity.styles.scss';

type DocumentsGlobalSecurityProps = {
  className?: string;
};

const DocumentsGlobalSecurity: React.FC<DocumentsGlobalSecurityProps> = (
  props,
) => {
  const { className } = props;

  const { dataRoom, doesntHaveAccess, fileSettingsInitialValues, setDataRoom } =
    useContext(DataRoomContext);

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  const { popSuccess, popServerError } = useContext(PopNotificationsContext);

  const classes = classNames('documents-global-security', className);

  const { t } = useTranslation();

  const onSubmit = useCallback(
    async (values) => {
      const { applyOnExistingFiles, ...rest } = values;
      const result = getPayloadBulkFileSettings(rest);

      modal.close();

      try {
        const { data } = await dataRoomApi.room.updateGlobalSecuritySettings(
          dataRoom._id,
          result,
          applyOnExistingFiles,
        );
        setDataRoom((prev) => ({ ...prev, ...data }));
        popSuccess(t('succesfullyUpdatedGlobalSecurity'));
      } catch (e) {
        popServerError(e);
      }
    },
    [dataRoom._id, modal, popServerError, popSuccess, setDataRoom, t],
  );

  return (
    <div className={classes}>
      <Form
        initialValues={fileSettingsInitialValues}
        onSubmit={onSubmit}
        render={({
          invalid,
          pristine,
          submitting,
          form: { change, submit },
          handleSubmit,
        }) => {
          return (
            <form onSubmit={handleSubmit}>
              <FileSecurity description={t('fileSecurityDescription')}>
                <div className="actions">
                  <Button
                    disabled={
                      doesntHaveAccess || invalid || pristine || submitting
                    }
                    onClick={modal?.open}
                  >
                    {t('save')}
                  </Button>
                </div>
              </FileSecurity>

              <ScopeModal
                ref={modalRef}
                onChoose={(applyOnExistingFiles) => {
                  change('applyOnExistingFiles', applyOnExistingFiles);
                  submit();
                }}
              />
            </form>
          );
        }}
      />
    </div>
  );
};

export default DocumentsGlobalSecurity;
